<template>
    <!-- <div id="Home">
        <a href="tel:0571-86221010"><img src="../../images/index/mainIndex1.jpg" alt="" /></a>

        <img src="../../images/index/mainIndex2.jpg" alt="" @click="toIntro" />
        <img src="../../images/index/mainIndex3.jpg" alt="" @click="toEnter" />
        <img src="../../images/index/mainIndex4.jpg" alt="" @click="to('Policy')" />
        <img src="../../images/index/mainIndex5.jpg" alt="" @click="to('Service')" />
        <img src="../../images/index/mainIndex6.jpg" alt="" @click="to('Finacy')" />
        <img src="../../images/index/mainIndex7.jpg" alt="" @click="to('Internet')" />
        <img src="../../images/index/mainIndex8.jpg" alt="" />
        <img src="../../images/index/mainIndex9.jpg" alt="" />
    </div> -->
    <div class="homeWrap">
        <div class="firstSection">
            <div class="imgBox ">
                <img src="../../images/newImages/home_bg_zongheti.png" alt="">
            </div>
            <div class="floatBlock">
                <div class="text">
                    <div class="title bold">服装产业创新服务综合体</div>
                    <div class="content">
                        聚空间、金融、政策、产业配套、互联网平台为一体的服装产业综合创新服务
                    </div>
                </div>
                <div class="btnBox">
                    <button  class="btn-white" @click="to('Policy')">
                        了解政策
                    </button>
                    <button  class="btn-red" @click="toIntro" >
                        综合体介绍
                    </button>
                </div>
            </div>
        </div>
        <div class="secondSection">
            <div class="title">产业互联网平台</div>
            <div class="redLine"><hr></div>
            <div class="subTitle">发布会订货系统+衣加加平台</div>
            <div class="imgBox">
                <img src="../../images/newImages/home_img_dinghuoxitong.png" alt="">
            </div>
            <div class="text">
                <p class="suojin textLeft liangduanduiqi ">
                   发布会订货系统是产业互联网平台旗下的一个SAAS服务模块，意在帮助品牌商更有效的进行发布会客户邀约，可独立生成专属邀请海报、邀请链接，在直接邀请已有客户的基础上实现粉丝裂变，吸引更多客户；对于活动的发起者有一个独立的管理后台，清晰显示客户邀约情况、订货情况，也可邀请其他品牌商一起参与活动，达到资源共享；后台直接打印订单，实现现场订货；后续对接衣加加供应链公共服务平台，可以让客户实时查看订单的生产进度。

                </p>
            </div>
            <div class="btnBox">
                <button  class="btn-red btn-long"  @click="to('InternetForm')">
                    申请使用订货会系统
                </button>
            </div>
        </div>
        <div class="thirdSection">
            <div class="imgBox">
                <img src="../../images/newImages/home_img_phone.png" alt="">

            </div>
            <div  class="rightBlock">
                <div class="title">衣加加服务云平台</div>
                <div class="text">
                    <p class="duanluo liangduanduiqi">
                        衣加加服务云平台是作为服装产业互联网平台订单总发单入口，用户可在系统内发布各类供应链相关订单，系统将及时处理并实时反馈订单处理的全过程信息，实现供应链快速、可控。
                    </p>
                </div>
            </div>
        </div>
        <div class="fourthSection">
            <div class="title">满足多种需求</div>
            <div class="content">
                <div class="left">
                    <div class="title">我要发单</div>
                    <div class="text">
                        品牌商等加工需求方通过系统能快速、高效找到适合订单需求的服装厂
                    </div>
                </div>
                <div class="right">
                    <div class="title">我要接单</div>
                    <div class="text">服装厂可以通过系统快速接到符合自己生产能力订单，同时线下配套建设的共享工厂</div>
                </div>
            </div>
            <div class="imgBox">
                <img src="../../images/newImages/home_img_y++.png" alt="">
            </div>
        </div>
        <div class="fifthSection">
            <div class="imgBox">
                <img src="../../images/newImages/home_bg_peitaochanye.png" alt="">

            </div>
            <div class="content">
                <div class="title">配套产业服务全面支持</div>
                <div class="redLine"><hr></div>
                <div class="subtitle">设计、生产、营销，全面数据全面贯通，企业运作效率全面提升</div>
                <div class="btnBox">
                    <button  class="btn-white" @click="to('Service')"> 
                        了解更多
                    </button>
                    <button  class="btn-red" @click="to('ServiceForm')">
                        服务申请
                    </button>
                </div>
            </div>
            
        </div>
        <div class="sixSection">
            <div class="title">战略合作单位</div>
            <div class="swiperContent">
                <el-carousel indicator-position="outside" :interval="3000" arrow="always">
                    <el-carousel-item v-for="(list1,index1) in swiperImgArr" class="logoSection" >
                      <el-row :gutter="10">
                          <el-col  :span="8" v-for="(list2,index2) in list1.urlArr">
                              <div class="logoBox">
                                  <img  :src="'static/companyLogo/'+list2+ '.png' " alt="">
                              </div>
                          </el-col>
                      </el-row>
                    </el-carousel-item>
               </el-carousel>
            </div>
        </div>
        <div class="sevenSection">
            <div class="imgBox ">
                <img src="../../images/newImages/home_bg_jinrong.png" alt="">
            </div>
            <div class="floatBlock">
                <div class="text">
                    <div class="title">针对服装产业的金融支持</div>
                    <div class="content">
                        天使梦想基金，让理性股权投资，政策性融资担保、小微企业集合债
                    </div>
                </div>
                <div class="btnBox">
                    <button  class="btn-yellow" @click="to('Finacy')">
                        千万金融支持，预约申报入口
                    </button>
                </div>
            </div>
        </div>
        <div class="eightSection">
            <div class="imgBox">
                <img src="../../images/newImages/erweima.png" alt="">
            </div>
            <div class="text">扫码关注公众号</div>
        </div>
        <div class="lastButtonSection fixedBottom">
            <a href="tel:0571-86221010">
            <button  class="btn-red reverse">
                
                    <img src="../../images/newImages/but_ic_phone.png" alt="" class="btnIcon">
                    联系我们
            </button>
            </a>
            <button  class="btn-red " @click="toEnterForm" >
                <img src="../../images/newImages/but_ic_ruzhu.png" alt="" class="btnIcon">
                入驻综合体
            </button>
        </div>
    </div>
</template>

<script>
    import {        ajaxCode,        ajaxLogin    } from '@/assets/request.js'
    import {        setCookie,        phoneReg,        codeReg,        filterPhoneNum,        GetRequest    } from '@/assets/common.js'
    export default {
        data() {
            return {
               paramObj:{},
              phone:'',
              code:'',
              swiperImgArr:[{
                  urlArr:['01','02','03','04','05','06']
              },{
                  urlArr:['07','08','09','10','11','12']
              },{
                  urlArr:['13','14','15','16','17','18']
              },{
                  urlArr:['19','20']
              }]
            }
        },
        methods: {
            to(url) {
                this.$router.push({
                    name: url
                });
            },
            toIntro() {
                this.$router.push({
                    name: 'BuildingIntro'
                });

            },
            toEnter() {
                this.$router.push({
                    name: 'BuildingEnter'
                });

            },
            toEnterForm() {
                this.$router.push({
                    name: 'BuildingEnterForm'
                });
            },
            login() {
                let _this = this
                ajaxLogin(_this.phone, _this.code).then(res => {

                  let token = JSON.parse(res.data).token
                  let userId = JSON.parse(res.data).userId
                  console.log(token, userId)
                  sessionStorage.setItem("isLogined", "1")
                  sessionStorage.setItem("token", token)
                  sessionStorage.setItem("userId", userId)
                  setCookie("global_token", token, 10)
                }, (res) => {
//                     this.$message.error({
//                         message: res.erroyMsg,
//                         duration: 1000,
//                     });
                })
            }
        },
        mounted() {
           this.paramObj = GetRequest()
           console.log(this.paramObj )
           this.phone = this.paramObj.p
           this.code = this.paramObj.c
           if (this.phone && this.code) {
               this.login()
           }
        }
    }
</script>

<style lang="less" scoped="scoped">
    .homeWrap{
        .fixedBottom{position: fixed;bottom: 0;width: 100%;z-index:100;}
        // *{outline: 1px solid blue}
        .redLine{line-height: 0.1rem; 
            hr{width: 1.7rem;border-top:0; border-color:#DE1D23;}
         }
        background: #fff;
        .firstSection{
            position: relative;
            .imgBox{
                img{width: 100%;}
            }
            .floatBlock{
                position: absolute;top:0;left:0; padding-left:0.4rem;padding-top:1.98rem;
                .text{
                    color:#fff;
                    .title{
                       font-size: 0.48rem;line-height: 0.668rem;
                    }
                    .content{font-size:0.3rem; width: 4rem;line-height: 0.44rem; padding-top:0.14rem;}
                }
                .btnBox{
                    margin-top:0.74rem;
                    button{font-size: 0.28rem;padding:0.24rem 0;width: 2.2rem;margin-right: 0.3rem;letter-spacing: 1px;}
                }
            }
            
            
        }
        .secondSection{
            text-align: center; padding:0 0.4rem;
            .title{font-size: 0.48rem;color:#111A34;padding-top:1rem; }
            .subTitle{font-size: 0.32rem;color:#858B9C;margin-bottom: 0.98rem;}
            .imgBox{
                img{width: 100%}
            }
            .text{font-size: 0.28rem;color:#0f0f0f;margin-top:0.67rem; line-height: 0.44rem;}
            .btnBox{
                margin-top:0.76rem;
            }
        }
        .thirdSection{
            margin-top:0.664rem; position: relative;
            .imgBox{
                img{width:60%;}
            }
            .rightBlock{
                position: absolute; top:2.4rem;right:0.4rem; width: 3.76rem;
                .title{color:#111A34;font-size: 0.42rem;margin-bottom: 0.24rem;}
                .text{color:#666;font-size: 0.28rem; line-height: 0.4rem;}
            }
        }
        .fourthSection{
            padding:0 0.4rem;
            .title{font-size:0.42rem;color:#DE1D23;}
            .content{
                margin-top:0.47rem;
                .title{font-size:0.28rem;color:#111A34; margin-bottom: 0.08rem;}
                .text{font-size: 0.24rem;line-height: 0.33rem;color:#999;}
                display: flex;
                .left{margin-right: 1.27rem;}
            }
            .imgBox{
                text-align: center; margin-top:1.4rem; margin-bottom: 1.72rem;
                img{width: 5.28rem;}
            }
        }
        .fifthSection{
            position: relative;
            .imgBox{
                img{width: 100%}
            }
            .content{
                opacity: 0.9;
                 position: absolute; height: 3.2rem; left:0;top:0;bottom: 0;margin:auto; text-align: center;
                color:#fff; 
                .title{font-size: 0.48rem;}
                .subtitle{padding:0 1.13rem;font-size: 0.3rem;color:#f9fafb; line-height: 0.42rem;}
                .btnBox{
                    margin-top:0.48rem;
                    button{
                        padding:0.24rem 0;
                        width: 2.2rem;
                    }
                    button:first-child{
                        margin-right: 0.3rem;
                    }
                }
            }
        }
        .sixSection{
            .title{font-size: 0.36rem;color:#DE1D23;text-align: center; margin-top:1.2rem;margin-bottom: 0.6rem;}
            .swiperContent{
                padding:0 0.4rem;
                .logoSection{
                    .logoBox{
                        width: 2.13rem; height: 1.96rem; background: #E2E4EA; margin-bottom: 0.6rem;
                        img{max-width: 100%;max-height: 100%;}
                    }
                }
            }
        }
        .sevenSection{
            margin-top:1.3rem; position: relative;
            .imgBox{
                img{width: 100%;}
            }
            .floatBlock{
                position: absolute; left:0.36rem; height: 3rem;top:0; bottom: 0;margin:auto;
                .text{
                    .title{color:#E1BC7F;font-size: 0.48rem; line-height: 0.67rem;margin-bottom: 0.11rem;}
                    .content{color:#fff;font-size: 0.31rem;line-height: 0.44rem;width: 4.73rem;margin-bottom: 0.41rem;}
                }
                .btnBox{
                    button{width: 4.25rem;padding:0.24rem 0;}
                }
            }
        }
        .eightSection{
            margin-top:1.2rem; padding-bottom: 2.5rem;
            .imgBox{
                text-align: center; margin-bottom: 0.36rem;
                img{width: 2.27rem;height: 2.27rem;}
            }
            .text{font-size: 0.3rem;color:#41485d;text-align: center; }
        }
        
    }
</style>



// WEBPACK FOOTER //
// src/page/introPage/Home.vue